export const symbolUrl = (url: string) => (url.indexOf('?') > -1 ? '&' : '?');
